import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withTranslation} from 'react-i18next';
import {compose} from 'redux';

import getLocations from '../../redux/actions/getLocations';
import LoadingSpinner from '../common/LoadingSpinner';
import Paper from '../common/Paper';
import MiddleBar from "../Location/MiddleBar";
import {ErrorAlert} from '../common/Alerts';
import LocationRow from './LocationRow';

import { TableWrapper, Table, Thead, TheadTr, Th } from './LocationTable.styled';


class LocationTable extends Component {
  offset = 0;
  limit = 500;
  rowHeight = 65;

  constructor(props) {
    super(props);

    const { t } = this.props;

    this.state = {
      columns: [
        { name: 'name', label: t('name'), width: '300' },
        { name: 'address', label: t('address'), width: '300' },
        { name: 'openingHours', label: t('openingHours'), width: '250' },
        { name: 'rating', label: t('rating'), width: '90' },
        { name: 'services', label: t('services'), width: '90' },
        { name: 'stations', label: t('stations'), width: '90' },
        { name: 'evse', label: 'EVSE', width: '90' },
        { name: 'evseInUse', label: t('evseInUse'), width: '90' },
      ],
    };
  }

  componentDidMount() {
    this.getLocations();
  }

  loadMore = () => {
    this.getLocations(true);
  };

  getLocations = (loadMore) => {
    const { authorization, getLocations, params } = this.props;

    getLocations(
      authorization,
      {
        mode: 'full',
        limit: this.limit,
        offset: this.offset,
        search: (loadMore && params?.search) || '',
      },
      () => {
        this.offset = this.offset + this.limit;
      },
      loadMore,
      loadMore,
    );
  }

  render() {
    const { columns } = this.state;
    const { data, loading, loadingMore, lastLoad, error } = this.props;

    if (loading) {
      return (
        <div style={{ flexGrow: 1 }}>
          <LoadingSpinner />
        </div>
      );
    }

    if (error && error.message) {
      return <ErrorAlert>{error.message}</ErrorAlert>;
    }

    const allColumnsWidth = columns.reduce((accumulator, currentValue) => accumulator + +currentValue.width, 0);

    return (
      <>
        <Paper padding="0">
          <TableWrapper style={{ width: `${allColumnsWidth}px` }}>
            <Table>
              <colgroup>
                {columns.map(col => <col key={col.name} width={col.width} />)}
              </colgroup>
              <Thead>
                <TheadTr>
                  {columns.map(col => <Th key={col.name}>{col.label}</Th>)}
                </TheadTr>
              </Thead>
              <tbody>
                {data && data.map((location, i) =>
                  <LocationRow key={i} {...location} />
                )}
              </tbody>
            </Table>
          </TableWrapper>
        </Paper>

        {!loadingMore && !lastLoad && (
          <MiddleBar
            buttonText="Подгрузить еще 50"
            buttonOnClick={this.loadMore}
          />
        )}

        {loadingMore && (
          <div style={{ height: '100px', position: 'relative' }}>
            <LoadingSpinner />
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = ({ manager, locations: { data, params, loading, loadingMore, lastLoad, error } }) => ({
  authorization: manager.accessToken && `Bearer ${manager.accessToken}`,
  data,
  params,
  loading,
  loadingMore,
  lastLoad,
  error,
});

const mapDispatchToProps = dispatch => ({
  getLocations: (...params) => dispatch(getLocations(...params)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps), withTranslation())(LocationTable);
